module.exports = __webpack_public_path__ + "media/img/patterns/crosshair-grid-dark-44d7fcfee069fe6fb5e9d56f8348ab73.png";